import { muiStyles } from 'utils/design';
import { colors } from 'styles/colors';

export const useStyles = muiStyles(() => ({
  hasError: {
    color: `${colors.red}`,
  },
}));
